import { FC } from 'react'
import { Page } from '@revolut-internal/ui-kit'

import { PermissionBoundary } from 'containers/PermissionBoundary'

import { AssistantPlaygroundContent } from './components'
import { AssistantChatMessagesProvider } from './providers'
import { useLatestAssistantChatMessage } from './hooks'

export const AssistantPlayground: FC = () => {
  const { data, isError, isLoading, retry } = useLatestAssistantChatMessage()

  return (
    <Page>
      <Page.Main>
        <PermissionBoundary
          permissions={['playground.assistant_text_generation.view.details']}
        >
          <AssistantChatMessagesProvider initialData={data}>
            <AssistantPlaygroundContent
              isLoading={isLoading}
              isError={isError}
              retry={retry}
            />
          </AssistantChatMessagesProvider>
        </PermissionBoundary>
      </Page.Main>
    </Page>
  )
}
